import React from 'react';
import { DEFAULT_SETTINGS, SiteSettings } from '@/hooks/useSiteContent';

const ICONS = ['globe', 'palm', 'wave'];

function FeatureIcon({ kind }: { kind: string }) {
  if (kind === 'globe')
    return (
      <svg viewBox="0 0 24 24" width="25" height="25" fill="none" stroke="currentColor" strokeWidth="1.45" aria-hidden="true">
        <circle cx="12" cy="12" r="10" />
        <ellipse cx="12" cy="12" rx="4.6" ry="10" />
        <path d="M2 12h20M12 2v20M3.6 7h16.8M3.6 17h16.8" />
      </svg>
    );
  if (kind === 'palm')
    return (
      <svg viewBox="0 0 24 24" width="27" height="27" fill="currentColor" aria-hidden="true">
        <path d="M11.2 8.6C9.6 6.4 6.5 5.6 3.6 6.8c2.4-.1 4.4.7 5.8 2.1-2.8-.4-5.6.9-7.1 3.4 2.2-1.4 4.8-1.7 7-.8.3-.6.9-1.4 1.9-2.9z" />
        <path d="M12.8 8.6c1.6-2.2 4.7-3 7.6-1.8-2.4-.1-4.4.7-5.8 2.1 2.8-.4 5.6.9 7.1 3.4-2.2-1.4-4.8-1.7-7-.8-.3-.6-.9-1.4-1.9-2.9z" />
        <path d="M12 8.3c-.3-2.6-2.3-4.6-5-5.1 1.9.9 3.2 2.5 3.7 4.3.5-2.1 2-3.9 4.3-4.6-2 1.3-2.8 3.2-3 5.4z" />
        <path d="M11.1 8.9h1.6c0 4.9.6 9.2 1.9 13.1h-1.8c-1.2-3.9-1.7-8.3-1.7-13.1z" />
      </svg>
    );
  return (
    <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
      <path d="M3.5 10v4M6.6 7.5v9M9.7 5v14M12.8 8v8M15.9 6v12M19 9.5v5" />
    </svg>
  );
}

export default function About({ about }: { about: SiteSettings['about'] }) {
  const isDefault = about.body.trim() === DEFAULT_SETTINGS.about.body;
  return (
    <section id="about" className="ek-about" aria-labelledby="about-title" data-testid="about-section">
      <div className="ek-about-media" role="img" aria-label="Havana fortress and city skyline at dusk — San Antonio, Havana, Ecuador" />
      <div className="ek-about-body">
        <h2 id="about-title" className="ek-about-title" data-testid="about-title">{about.title}</h2>
        <p className={`ek-about-copy ${isDefault ? '' : 'is-custom'}`} data-testid="about-body">
          {isDefault ? (
            <>
              The Ekuba Project is the electronic music project of Ernesto Couso, <br className="ek-dbr" />
              based in San Antonio, Texas, with deep roots in Havana, Cuba and Ecuador. <br className="ek-dbr" />
              Since 2010, the project has explored the fusion of house and tech-house <br className="ek-dbr" />
              with Latin instruments and melodies, creating a unique sound that connects <br className="ek-dbr" />
              cultures, dance floors and people.
            </>
          ) : (
            about.body
          )}
        </p>
        <ul className="ek-about-feats">
          {about.features.slice(0, 3).map((f, i) => (
            <li key={i} className={`ek-feat ek-feat-${i}`} data-testid={`about-feature-${i}`}>
              <span className="ek-feat-ico">
                <FeatureIcon kind={ICONS[i]} />
              </span>
              <span className="ek-feat-label">
                {f.line1}
                <br />
                {f.line2}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
